module.exports = __webpack_public_path__ + "img/_zarchiwizowane.bc7875ed.png";